import { FaceTecSDK } from "../vendor/core-sdk/v9-7-136/FaceTecSDK.js/FaceTecSDK";

export default FaceTecSDK;